export { default } from "./SettingsModal"



// WEBPACK FOOTER //
// ./src/components/settings-modal/index.js